import { createFileRoute } from '@tanstack/react-router';
import InvoiceSyncView from '../admin/invoice-sync/view';
export const Route = createFileRoute('/admin/invoices/sync-vin-amounts')({
  component: InvoiceSyncView,
});
